import { ColumnData } from './column-data';
import { BaseEntity } from './base-entity';
import { QueryParameter } from './query-parameter';
import { UserService } from '../base-services/user.service';
import { RefreshType } from './refresh-type';
import { DefaultListType } from './default-list-type';
import { DefaultListButtonsOptions } from './default-list-buttons-options';
import { TableColumnsSum } from './table-columns-sum';
import { TableRowColor } from './table-row-color';
import { IDefaultListFilter } from '../base-components/default-list/default-list-filter.interface';
import { RequestType } from './request-type';
import { DefaultButtonsConfig } from '../base-models/default-buttons-config';
import { TableContextMenuItem } from '../base-components/default-table/table-context-menu-item';
import { TableContextMenu } from '../base-components/default-table/table-context-menu';
import { ModalSize } from './modal-size';
export class ListData {

    constructor(private userService: UserService){}

    ModelName: string;
    //ShortModelName: string;
    GetName: string;
    SelectName: string;
    GetParameters: QueryParameter[];
    ParentProperty: string;
    ModelClass: new() => any;
    ShortModelClass: new() => any;
    TableColumns: ColumnData[];
    SortBy: string;
    SortReverse: boolean;
    DetailList: ListData[];
    DefaultListButtonsConfig: DefaultButtonsConfig;
    // EnableAdd: boolean;
    EnableEdit: boolean;
    EnableDelete: boolean;
    EnablePrint: boolean;
    EnablePrintAccountSelection:boolean;
    UpdateComponent: any;
    FormType: string;
    RefreshType: RefreshType;
    CloseAfterSave: boolean;
    ShowOnFirstPage: boolean;
    PrintName: string;
    DefaultPropertyName: string;
    DefaultListType: DefaultListType;
    ColumnClass: string;
    DefaultListButtonsOptions: DefaultListButtonsOptions;
    FormControlDataName: string;
    LoadFormControlDataOnInit: boolean;
    TableColumnBorderEven: boolean;
    TableColumnBorderOdd: boolean;
    TableColumnsSums: TableColumnsSum[];
    TableRowColors: TableRowColor[];
    DefaultListFilterComponent: any;
    RequestType: RequestType;
    TableContextMenuItems: TableContextMenuItem[];
    PrintType: string;
    PrintController: string;
    UserRightsModelName: string;
    ShowCheckBoxes: boolean;
    EditIcon: string;
    CustomPrint: boolean;
    Pagination: boolean;
    TableContextMenu: TableContextMenu[];
    //ShowDefaultListToolbar: boolean;
    ModalSize: ModalSize;
    Label: string;
    RefreshMainlistItem: boolean = false;
    EnableColumnRatioOptions: boolean;

    LoadListData(data: any): ListData {
        // console.log('LoadListData called');
        if(data){
        //let listData = new ListData();
        this.ModelName = data.modelName;
        //this.ShortModelName = this.getShortModelName(data.shortModelName, data.modelName);
         this.GetName = data.getName;
         this.SelectName = data.selectName;
        this.GetParameters = data.getParameters;
          this.ModelClass = data.modelClass;
          this.ModalSize = data.modalSize != null ? data.modalSize : ModalSize.Lg;
        this.ShortModelClass = this.getShortModelClass(data.shortModelClass, data.modelClass);
        //this.TableColumns = data.tableColumns;
        this.TableColumns = new ColumnData(this.userService).LoadColumnData(data.tableColumns);
          this.SortBy = data.sortBy;
          this.Label = data.label;
          this.SortReverse = data.sortReverse;
          this.RefreshMainlistItem = data.refreshMainlistItem;
          this.EnableColumnRatioOptions = data.enableColumnRatioOptions !== false;

        this.DetailList = [];
          if (data.detailList) {
            this.DetailList = data.detailList.map(detailData => {
              const detail = new ListData(this.userService).LoadListData(detailData);

              // Rekurzivno popuni nested detailList
              if (detailData.detailList) {
                detail.DetailList = detailData.detailList.map(nestedData => {
                  return new ListData(this.userService).LoadListData(nestedData);
                });
              }

              return detail;
            });
          }
        this.ShowCheckBoxes = data.showCheckBoxes != null ? data.showCheckBoxes : true;
        this.DefaultListButtonsConfig = new DefaultButtonsConfig().GetConfig(data.userRightsModelName ? data.userRightsModelName : data.modelName, this.ShowCheckBoxes, this.getDefaultListConfig(data.defaultListConfig));
        this.EnableEdit = this.getEnableEdit(data.enableEdit);
        this.EnableDelete = this.getEnableDelete(data.enableDelete);
        this.UserRightsModelName = data.userRightsModelName ? data.userRightsModelName : data.modelName;
        
        // this.EnableDelete = new DefaultButtonsConfig().GetConfig(this.UserRightsModelName ? this.UserRightsModelName : this.ModelName, this.ShowCheckBoxes, this.getDefaultListConfig(data.defaultListConfig)).DeleteButtonConfig.Enable;
        // this.EnableEdit = new DefaultButtonsConfig().GetConfig(this.UserRightsModelName ? this.UserRightsModelName : this.ModelName, this.ShowCheckBoxes, this.getDefaultListConfig(data.defaultListConfig)).EditButtonConfig.Enable;
        this.EnableDelete = this.DefaultListButtonsConfig.DeleteButtonConfig.Enable;
        this.EnableEdit =this.DefaultListButtonsConfig.EditButtonConfig.Enable;

        this.EnableEdit = new DefaultButtonsConfig().GetConfig(this.UserRightsModelName ? this.UserRightsModelName : this.ModelName, this.ShowCheckBoxes, this.getDefaultListConfig(data.defaultListConfig)).EditButtonConfig.Enable;
        this.EnablePrint = this.getEnablePrint(data.enablePrint);
        this.EnablePrintAccountSelection=this.getEnablePrintAccountSelection(data.enablePrintAccountSelection);
        this.ParentProperty = data.parentProperty;
        this.UpdateComponent = data.updateComponent;
        this.FormType = data.formType ? data.formType : 'templateDriven';
        this.RefreshType = data.refreshType ? data.refreshType : 'noReload';
        this.CloseAfterSave = data.closeAfterSave != null ? data.closeAfterSave : true;
        this.ShowOnFirstPage = data.showOnFirstPage != null ? data.showOnFirstPage : true;
        this.PrintName = data.printName;
        this.DefaultPropertyName = data.defaultPropertyName != null ? data.defaultPropertyName : this.TableColumns[0].Name;
        this.DefaultListType = data.defaultListType != null ? data.defaultListType : DefaultListType.List;
        this.ColumnClass = data.columnClass != null ? data.columnClass : this.DetailList.length == 0 ? 'col-md-12' : 'col-md-6';
        this.DefaultListButtonsOptions = new DefaultListButtonsOptions().Load(data.defaultListButtonsOptions);
        this.FormControlDataName = data.formControlDataName;
        this.LoadFormControlDataOnInit = data.loadFormControlDataOnInit ? data.loadFormControlDataOnInit : true;
        this.TableColumnBorderEven = data.tableColumnBorderEven ? data.tableColumnBorderEven : false;
        this.TableColumnBorderOdd = data.tableColumnBorderOdd ? data.tableColumnBorderOdd : false;
        this.TableColumnsSums = new TableColumnsSum().LoadTableColumnsSum(data.tableColumnsSums);
        this.TableRowColors = data.tableRowColors ? data.tableRowColors : null;
        this.DefaultListFilterComponent = data.defaultListFilterComponent ? data.defaultListFilterComponent : null;
        this.RequestType = data.requestType ? data.requestType : RequestType.GET;
        this.TableContextMenuItems = data.tableContextMenuItems ? new TableContextMenuItem().LoadItems(
            data.tableContextMenuItems
            , data.userRightsModelName ? data.userRightsModelName : data.modelName
        ) : [];
          this.TableContextMenu = data.tableContextMenu ? new TableContextMenu().LoadItems(
            data.tableContextMenu
            , data.userRightsModelName ? data.userRightsModelName : data.modelName
          ) : [];
        this.PrintType = data.printType ? data.printType : 'document';
        this.PrintController = data.printController ? data.printController : null;
        
        this.EditIcon = data.editIcon ? data.editIcon : 'fa-pencil-alt';
          this.CustomPrint = data.customPrint ? data.customPrint : false;
          this.Pagination = data.pagination ? data.pagination : false;
        }
        return this;
    }

    private getEnableAdd(enableAdd){
        if(enableAdd)
            return enableAdd;
        return false;
    }


    private getEnableEdit(enableEdit){
        if(enableEdit)
            return enableEdit;
        return false;
    }

    private getEnableDelete(enableDelete){
        if(enableDelete)
            return enableDelete;

        return false;
    }

    private getEnablePrint(enablePrint){
        if(enablePrint)
            return enablePrint;
        return false;
    }

    // Miša, 02.10.2020
    // Ovako dok ne organizujemo opcije štampe na pametniji način
    private getEnablePrintAccountSelection(enableAccountSelection){
        if(enableAccountSelection)
            return enableAccountSelection;
        return false;
    }

    private getShortModelName(shortModelName, modelName){
        if(shortModelName)
            return shortModelName;
        return modelName;
    }

    private getShortModelClass(shortModelClass, modelClass){
        if(shortModelClass)
            return shortModelClass;
        return modelClass;
    }

    private getDefaultListConfig(data){
        let config = {
            showToolbar: true,
            showAddButton: true,
            showDeleteAllButton: true,
            showPrintButton: true
        };

        if(!data){
            return config;
        }

        if(data.showToolbar != null){
            config.showToolbar = data.showToolbar;
        }

        if(data.showAddButton != null){
            config.showAddButton = data.showAddButton;
        }

        if(data.showDeleteAllButton != null){
            config.showDeleteAllButton = data.showDeleteAllButton;
        }

        if(data.showPrintButton != null){
            config.showPrintButton = data.showPrintButton;
        }

        return config;
    }
}
